import styled from "styled-components";

export const Wrapper = styled.div`
  min-height: calc(100vh - var(--page-header-height));
  padding: 0 0 84px 0;
  position: relative;
`;
